<template>
  <div>
    <v-form @submit.prevent="submitResponse">
      <p class="mb-2">Determine the relative polarity of the following compounds.</p>

      <p class="pl-4 mb-6">
        <v-img style="max-width: 500px" :src="imageName" />
      </p>

      <drag-to-rank-input
        v-model="inputs.relativePolarities"
        :items="items"
        class="mb-0"
        style="max-width: 512px"
        prepend-text="Most Polar"
        append-text="Least Polar"
      />
    </v-form>
  </div>
</template>

<script>
import DynamicQuestionMixin from '../../mixins/dynamic-question';
import ChemicalLatex from '../displayers/ChemicalLatex';
import StembleLatex from '@/tasks/components/StembleLatex';
import DragToRankInput from '@/tasks/components/inputs/DragToRankInput.vue';
import {prefixPublicAsset} from '@/common/plugins/public-asset-plugin';

export default {
  name: 'uOttawa1321Prelab1Q3',
  components: {
    DragToRankInput,
    ChemicalLatex,
    StembleLatex,
  },
  mixins: [DynamicQuestionMixin()],
  data() {
    return {
      inputs: {
        relativePolarities: [],
      },
      items: ['$\\text{Mol. A}$', '$\\text{Mol. B}$', '$\\text{Mol. C}$', '$\\text{Mol. D}$'],
    };
  },
  computed: {
    imageName() {
      return prefixPublicAsset('/img/assignments/rankPolarities1.png');
    },
  },
};
</script>
